import { Component, EventEmitter, Input, Output, ViewChild, ElementRef, OnInit, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-banner',
  template: `
  <div class="banner-container">
    <div class="banner-header">
      <div class="banner-header__title">
        <h2 class="font-michelin-unit-titling-Bold">TEVE ALGUM PROBLEMA COM O SEU PNEU MICHELIN?</h2>
        <p>VOCÊ PODE REGISTRAR A SUA RECLAMAÇÃO AQUI.</p>
      </div>
        <img src="https://admin.designsystem.michelin.com/uploads/attachments/clq3zk6hr003g7ff53dpefrh1-bibendum-homepage.svg" style="
    max-width: 190px;" class="hide-mobile"/>
    </div>
    <div class="banner-content">
      <div class="banner-content__box scroll-fade-in">
        <div class="banner-content__box-txt">   
        <p>
            Informamos que sua reclamação será tratada por nossos técnicos. 
            Caso as informações fornecidas estejam todas corretas, o prazo para a tratativa é de até 30 dias,
             conforme estabelecido pelo Código de Defesa do Consumidor. Estamos à disposição para quaisquer esclarecimentos adicionais.
        </p>
        </div>
        <div class="banner-content__box-img hide-mobile">   
          <img src="assets/images/img-01.png" />
        </div>
      </div>
      <div class="banner-content__box scroll-fade-in" style="animation-delay: 0.2s">
          <div class="banner-content__box-img  hide-mobile">   
            <img src="assets/images/img-02.png" />
          </div>
          <div class="banner-content__box-txt">   
            <p>
               Para que possamos analisar o dano do seu pneu, pedimos que você faça upload de algumas fotos do pneu danificado.
            </p>
          </div>
      </div>
    </div>
    <div class="banner-footer">
      <p> <strong class="font-michelin-unit-titling-Bold">ATENÇÃO:</strong></p>
      <p>
        Todas as informações sinalizadas com um<span class="required-dot">*</span>
        são obrigatórias para que a sua solicitação seja encaminhada.
      </p>
    </div>
</div>
  
  `,
  styles: [
    `
    .banner-container {
    border-radius: 10px;
    position: relative;
    color: #27509b;
    margin: auto;
  }
  .banner-header {
    display: flex;
    background: #d4e7fa;
    padding: 50px 40px 0px 20px;
    align-items: center;
    border-radius: 10px;
  }

  .banner-header__title {
    width: 80%;
    padding: 0 50px;
  }

  .banner-content__box-img img {
    max-width: 400px;
  }

  .banner-content__box-txt {
    background: #27509b;
    height: 100%;
    display: flex;
    align-items: center;
    transition: background 0.4s ease;
  }

  .banner-content {
    padding: 15px 0;
    border-radius: 5px;
    margin: 10px 0;
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .banner-content__box-txt p {
    padding: 14px !important;
    font-size: 18px !important;
    color: white;
  }

  .banner-content__box {
   background-color: #fff;
    border-radius: .5rem;
    color: #27509b;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(50%, 1fr));
    align-items: center;
    text-align: center;
    margin: 15px 0;
    transition: all 0.4s ease;
    cursor: pointer;
    
    &:hover {
      transform: translateY(-8px) scale(1.02);
      box-shadow: 0 12px 28px rgba(39, 80, 155, 0.15);
      
      .banner-content__box-txt {
        background: #1e4080;
      }
      
      .banner-content__box-img img {
        transform: scale(1.05);
      }
    }
  }

  .banner-content__box-img img {
    transition: transform 0.4s ease;
  }

  .banner-content__box p {
    font-size: 14px;
  }
    .banner-logo {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 100px;
    }

    .required-dot {
      color: red;
    }

    .banner-footer {
      font-size: 15px;
      text-align: center;
      padding: 15px;
      margin: 10px 0;
      background: #27509b;
      color: white;
      border-radius: 10px;
    }

    @keyframes scrollFadeIn {
      from {
        opacity: 0;
        transform: translateY(60px) scale(0.95);
      }
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }

    .scroll-fade-in {
      opacity: 0;
      transform: translateY(60px) scale(0.95);
      transition: opacity 1s ease-out, transform 1s ease-out;
    }

    .scroll-fade-in.visible {
      opacity: 1;
      transform: translateY(0) scale(1);
    }

    @media (prefers-reduced-motion: no-preference) {
      .scroll-fade-in.visible {
        animation: scrollFadeIn 1s ease-out forwards;
      }
    }
    `
  ]
})
export class BannerComponent implements AfterViewInit {
  
  ngAfterViewInit(): void {
    // Intersection Observer para animação ao scroll
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    // Observar todos os elementos com a classe scroll-fade-in
    const elements = document.querySelectorAll('.scroll-fade-in');
    elements.forEach(el => observer.observe(el));
  }
}
